// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__5Wzct","white":"styles_white__e0lAf"};